<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Fatura Aktarım Kuyruğu</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
              <div class="row col-lg-12">
                <form
                  class="m-form m-form--fit m-form--label-align-right col-lg-12"
                >
                  <div class="m-portlet__body">
                    <div class="form-group m-form__group row">
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Fatura Başlangıç Tarihi."
                          v-model="seachModel.startInvoiceDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Fatura Bitiş Tarihi."
                          v-model="seachModel.endInvoiceDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-4">
                        <input
                          type="text"
                          v-model="seachModel.invoiceNumber"
                          class="form-control m-input"
                          placeholder="Fatura Numarası."
                        />
                      </div>
                    </div>
                    <div class="form-group m-form__group row">
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Yükleme Başlangıç Tarihi."
                          v-model="seachModel.startInsertedDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-4">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Yükleme Bitiş Tarihi."
                          v-model="seachModel.endInsertedDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-2">
                        <select
                          class="form-control m-input"
                          placeholder="Durum."
                          v-model="seachModel.gibStatus"
                        >
                          <option :value="null">Gib Durum.</option>
                          <option
                            v-for="option in status"
                            v-bind:value="option.id"
                            v-bind:key="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-2">
                        <select
                          class="form-control m-input"
                          placeholder="Durum."
                          v-model="seachModel.logoStatus"
                        >
                          <option :value="null">Logo Durum.</option>
                          <option
                            v-for="option in status"
                            v-bind:value="option.id"
                            v-bind:key="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                     <div class="form-group m-form__group row">
                        <div class="col-lg-4">
                        <input
                          type="text"
                          v-model="seachModel.fileName"
                          class="form-control m-input"
                          placeholder="Dosya Adı."
                        />
                      </div>
                      
                      <div style="margin-top:10px;" class="col-lg-1">
                          <label>Excel'e Aktar</label>
                          </div>
                        <div class="col-lg-1">
                        <input
                          type="checkbox"
                          style="height:30px;margin-top:10px;"
                          v-model="seachModel.isExport"
                          class="form-control m-input checkbox checked"
                          placeholder="Excel."
                        />
                        </div>
                      </div>
                    
                    <div class="form-group m-form__group row">
                      <div class="col-lg-1">
                        <button
                          type="button"
                          @click="search()"
                          class="spbtn"
                        >
                          Ara
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!--begin: Datatable -->
              <div
                id="m_table_1_wrapper"
                class="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="
                        table
                        table-striped-
                        table-bordered
                        table-hover
                        table-checkable
                        dataTable
                        no-footer
                        dtr-inline
                      "
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            Numara
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            Dosya Adı
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Gib Durum
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Logo Durum
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Logo Referans
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Gib Referans
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Gib Mesaj
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Logo Mesaj
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Yükleme Tarihi
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="model.items && model.items.length">
                        <tr
                          role="row"
                          class="odd"
                          v-for="item in model.items"
                          v-bind:key="item.id"
                        >
                          <td>{{ item.invoiceNumber }}</td>
                          <td>{{ item.fileName }}</td>
                          <td>{{ item.gibStatusDescription }}</td>
                          <td>{{ item.logoStatusDescription }}</td>
                          <td>{{ item.logoRecordRef }}</td>
                          <td>{{ item.gibRecordRef }}</td>
                          <td>
                            <div style="height: 80px; overflow: auto">
                              {{ item.gibLastErrorMessage }}
                            </div>
                          </td>
                          <td>
                            <div style="height: 80px; overflow: auto">
                              {{ item.logoLastErrorMessage }}
                            </div>
                          </td>
                          <td>
                            {{
                              item.insertedDate
                                | moment( false, "yyyy-MM-dd'T'HH:mm").format(
                                  "DD/MM/YYYY"
                                )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
          <div class="m-portlet m-portlet--mobile">
            <paginate
              :page-count="
                Math.ceil(this.model.totalCount / this.model.pageSize)
              "
              :click-handler="changePage"
              :prev-text="'<<'"
              :next-text="'>>'"
              :container-class="'pagination'"
              :page-class="'pageclass'"
              :next-link-class="'pageclass'"
              :prev-link-class="'pageclass'"
              :active-class="'active'"
            >
              >
            </paginate>

          

            <!-- <paginate
              :page-count=" Math.ceil(this.model.totalCount / this.model.pageSize)"
              :click-handler="changePage"
              :prev-text="'<<'"
              :next-text="'>>'"
              :container-class="'pagination'">
            </paginate> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.pagination {
  color: black;
  float: left;
  padding: 8px 8px;
  text-decoration: none;  
}

.pageclass{
   color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #ddd;
}
.active{
  background-color: #5aa3ff;
  border:1px;
}
</style>
<script>
import {
  _searchInvoiceQueues,
  _getProcessStatusEnumDescriptionStatus,
} from "../../services/InvoiceService";

import {
  _excelExport,
} from "../../services/ExportService";

import datepicker from "vuejs-datepicker";

// register jw pagination component globally
import JwPagination from 'jw-vue-pagination';

export default {
  data() {
    return {
      JwPagination,
      model: {
        items: [],
        page: 0,
        pageSize: 0,
        totalCount: 0,
      },
      seachModel: {
        invoiceNumber: null,
        gibStatus: null,
        logoStatus: null,
        startInvoiceDate: null,
        endInvoiceDate: null,
        startInsertedDate: null,
        endInsertedDate: null,
        transferMessage: null,
        page: null,
        isExport: false,
        fileName:null,
      },
      status: [],
    };
  },
  created() {
    this.getStatus();
  },
  components: {
    datepicker: datepicker,
  },
  methods: {
    getAll: function () {
      // let loader=this.$loading.show();
      _searchInvoiceQueues(this.seachModel).then((response) => {
        this.model = response.data.data;
        if(response.data.data.isExport)
        {
_excelExport(response.data.data.exportData)
        }
      });
    },
    changePage: function (page) {
      this.seachModel.page = page;
      this.getAll();
    },
    getStatus: function () {
      _getProcessStatusEnumDescriptionStatus().then((response) => {
        this.status = response.data;
      });
    },
    search: function () {
      this.seachModel.page = 1;
      this.getAll(this.seachModel);
    },
  },
};
</script>
